import axios from 'axios'
import { SERVER_URI } from '../utils/config'
import { checkToken } from './checkToken'

export const dbdelete = async (table, id) => {
	checkToken()
	try{
		const response = await axios.delete(`${SERVER_URI}/${table}/${id}`)
		return response.data
	} catch (err) {
		console.error(err)
		throw new Error('Error deleting data')
	}
}
